import React from 'react';
import type { TextButtonProps } from '@wix/design-system';
import { Chat, HelpCircle, Hint } from '@wix/wix-ui-icons-common';
import { type TFunction } from '@wix/yoshi-flow-editor';
import { DataHooks } from '@app/constants';
import type { useBiLogger } from '@app/hooks';
import type { ArticleKeys } from './get-support-link';

export type ArticlesListContent = {
  articleKey: ArticleKeys;
  dataHook: string;
  title?: string;
  link: string;
  prefixIcon?: TextButtonProps['prefixIcon'];
  withDivider?: boolean;
  biKey?: keyof ReturnType<typeof useBiLogger>['biSupport'];
};

export const getArticles = (
  t: TFunction,
): Record<'questionArticles' | 'extraArticles', ArticlesListContent[]> => ({
  questionArticles: [
    {
      articleKey: 'wix_technical_assistant',
      dataHook: DataHooks.kbWixTechnicalAssistant,
      title: t('adsense.settings.support.technical_assistant.text'),
      link: t('adsense.settings.support.technical_assistant.link'),
      prefixIcon: <Hint />,
      withDivider: true,
      biKey: 'wixAssistantClick',
    },
    {
      articleKey: 'google_adsense_support',
      dataHook: DataHooks.kbGoogleAdsenseSupport,
      title: t('adsense.settings.support.google_adsense_help.text'),
      link: t('adsense.settings.support.google_adsense_help.link'),
      prefixIcon: <HelpCircle />,
      withDivider: true,
      biKey: 'adsenseHelpClick',
    },
    {
      articleKey: 'contact_customer_care',
      dataHook: DataHooks.kbContactCustomerCare,
      title: t('adsense.settings.support.customer_care.text'),
      link: t('adsense.settings.support.customer_care.link'),
      prefixIcon: <Chat />,
      biKey: 'contactCustomerCareClick',
    },
  ],
  extraArticles: [
    {
      articleKey: 'how_to_duplicate_ads_on_a_page',
      dataHook: DataHooks.kbDuplicateAdUnit,
      link: t(
        'adsense.settings.support.help_center.how_to_duplicate_ads_on_a_page',
      ),
    },
    {
      articleKey: 'adding_and_setting_up_ads',
      dataHook: DataHooks.kbAddingAndSettingAdUnit,
      link: t('adsense.settings.support.help_center.adding_and_setting_up_ads'),
    },
    {
      articleKey: 'how_to_connect_ad_units',
      dataHook: DataHooks.kbConnectAdUnit,
      link: t('adsense.settings.support.help_center.how_to_connect_ad_units'),
    },
  ],
});
